/*
    GR structure:{
        offset:{},
        nodes:{},
        links:{},
        selected: {},
        hovered: {}
    }
 */
import { IF } from "./nodeTypes";
import { dbType } from "./mrTypes";
export const GrToJdcWorkflow = (slug, id, GR) => {
  return {
    slug: slug,
    quantifier: GR.quantifier ? GR.quantifier : "one",
    id: id,
    nodes: nodeGrToNodeJdc(GR.nodes),
    connections: linkToConnections(GR.links, GR.nodes),
  };
};
export const GrToJdcModel = (GR) => {
  const { nodes, links } = GR;
  return {
    models: nodeGrToJdcModel(nodes),
    connections: linkToConnections(links, nodes),
  };
};
const nodeGrToNodeJdc = (nodes) => {
  const jdcNodes = [];
  for (const key of Object.keys(nodes)) {
    const node = nodes[key];
    //the node object is assembled according to the standard of jdc->workflow
    const jdcNode = {
      args: node.properties.args,
      id: key,
      name: node.properties.name,
      type: node.type,
      position: node.position,
    };
    jdcNodes.push(jdcNode);
  }
  return jdcNodes;
};
const nodeGrToJdcModel = (nodes) => {
  const jdcModels = [];
  for (const key of Object.keys(nodes)) {
    const model = nodes[key];
    //the model object is assembled according to the standard of jdc->model
    const jdcModel = {
      id: key,
      name: model.properties.name,
      type: model.type,
      source: model.properties.source,
      attributes: model.properties.attributes,
      position: model.position,
    };
    jdcModels.push(jdcModel);
  }
  return jdcModels;
};
const linkToConnections = (links, nodes) => {
  let connections = {};
  const relationConnections = {};
  for (const key of Object.keys(links)) {
    const link = links[key];
    const otherProps = {};
    const parentNodeId = link.from.nodeId;
    const tmpConnection = connections[parentNodeId];
    //TODO: check if the connection is already declared, and use it if it is
    const targets = tmpConnection ? tmpConnection.targets : [];
    //the attributes will be added to the connection consequent to the type of node
    if (nodes[parentNodeId].type === IF) {
      if (!tmpConnection) {
        //an extra operation is performed in case the parent node is an "IF
        targets.push({
          //the objects "yes" and "no" are added, following the structure of the "if" connection
          yes: [],
          no: [],
        });
      }
      const tmp = ifCase(link, nodes[parentNodeId]);
      targets[0][tmp.value].push({
        node: tmp.nodeId,
        executionMode: "sync", //in the future will be adjusted to the type of connection ("async" or "sync")
      });
    } else if (nodes[parentNodeId].type === dbType && link.properties) {
      //FIX: link.properties: Cannot read property 'connectionsProps' of undefined
      targets.push({
        id: link.to.nodeId,
        ...link.properties.connectionsProps,
      });
      otherProps["model"] = nodes[link.from.nodeId].properties.name;
      if (link.properties && link.properties.secondAssociation) {
        const associationKey = link.to.nodeId;
        const secondAssociation = relationConnections[associationKey] // en el caso que exista una realicion asociada (ejemplo: belong-to a has-many)
          ? relationConnections[associationKey]
          : {
              model: link.properties.secondAssociation[associationKey].model,
              targets: [],
            };
        secondAssociation.targets.push(
          link.properties.secondAssociation[associationKey].target
        );
        //se verifica si el modelo de la asociación actual ya esta incluido en alguna conexion
        //si es asi, se añade esta asociación a sus targets
        secondAssociation.targets.forEach((target) => {
          if (
            target &&
            relationConnections[target.id] &&
            targets.length > 0 &&
            !relationConnections[target.id].targets.some(
              (t) =>
                t &&
                t.id === targets[0].id &&
                t.model === targets[0].model &&
                t.target === targets[0].target &&
                t.origin === targets[0].origin
            )
          ) {
            relationConnections[target.id].targets.push(targets[0]);
          }
        });
        relationConnections[associationKey] = secondAssociation;
      }
    } else {
      targets.push({
        node: link.to.nodeId,
        executionMode: "sync",
      });
    }
    //a connection is added or an existing one is updated
    const joinedTargets =
      connections[parentNodeId] && connections[parentNodeId].targets
        ? [...connections[parentNodeId].targets, ...targets]
        : targets;
    connections[parentNodeId] = {
      ...otherProps, //the attribute "model" is added if the connection is of the model type
      targets: joinedTargets,
    };
  }
  connections = {
    ...connections,
    ...relationConnections,
  };
  return connections;
};

const ifCase = (link, node) => {
  const port = link.from.portId;
  return { value: node.ports[port].properties.value, nodeId: link.to.nodeId };
};
